import { clientUrls } from './account/clients'

export type ENV = 'development' | 'production' | 'local'

const { NODE_ENV } = process.env
const APP_ENV = 'CF_APP_ENV' as ENV
const BASENAME = '/accounts'

export interface ConfigType {
  API_HOST: string
  APP_ENV: ENV
  APPTIMIZE_APP_KEY: string
  AON_AUTHORIZE_URL: string
  ASSETS_HOST: string
  AUTH_DOMAIN: string
  BASENAME: string
  COBROWSE: string
  DCH_HOST_NAME: string
  DTP_HOST_NAME: string
  DY_CAMPAIGNS_URL: string
  DY_SECTION_ID: string
  IVA_HOST: string
  MARKETPLACE_URL: string
  PARTNER_APIGEE_CLIENT_ID: string
  PSCC_APIGEE_CLIENT_ID: string
  PSCC_PAY_AS_GUEST_URL: string
  PSCC_URL: string
  RC_APIGEE_CLIENT_ID: string
  SECURITY_CENTER_URL: string
  SERVICE_FILES: string
  TARGET_ORIGIN: (client?: string) => string
  UNIVERSAL_APIGEE_CLIENT_ID: string
  UTAG_URL: string
  VANTAGE_REMOTE_URL: string
  PROFILE_REMOTE_URL: string
  STATEMENTS_REMOTE_URL: string
  MAKE_A_PAYMENT_REMOTE_URL: string
  REMOTE_URL: string
}

export const setTargetOrigin = (environment: ENV, client?: string): string => {
  const currentClient = client || localStorage.getItem('client')
  if (String(environment) === 'production') {
    const clientUrl = clientUrls[currentClient]
    if (clientUrl) {
      return clientUrl
    }
  }
  return `https://${window.location.host}`
}

const prodConfig: ConfigType = {
  API_HOST: 'CF_API_HOST',
  APP_ENV,
  APPTIMIZE_APP_KEY: 'CF_APPTIMIZE_APP_KEY',
  AON_AUTHORIZE_URL: 'CF_AON_AUTHORIZE_URL',
  ASSETS_HOST: 'CF_ASSETS_HOST',
  AUTH_DOMAIN: 'CF_AUTH_DOMAIN',
  BASENAME,
  COBROWSE: 'CF_COBROWSE',
  DCH_HOST_NAME: 'CF_DCH_HOST_NAME',
  DTP_HOST_NAME: 'CF_DTP_HOST_NAME',
  DY_CAMPAIGNS_URL: 'CF_DY_CAMPAIGNS_URL',
  DY_SECTION_ID: 'CF_DY_SECTION_ID',
  IVA_HOST: 'CF_IVA_HOST',
  MARKETPLACE_URL: 'CF_MARKETPLACE_URL',
  PARTNER_APIGEE_CLIENT_ID: 'CF_PARTNER_APIGEE_CLIENT_ID',
  PSCC_APIGEE_CLIENT_ID: 'CF_PSCC_APIGEE_CLIENT_ID',
  PSCC_PAY_AS_GUEST_URL: 'CF_PSCC_PAY_AS_GUEST_URL',
  PSCC_URL: 'CF_PSCC_URL',
  RC_APIGEE_CLIENT_ID: 'CF_RC_APIGEE_CLIENT_ID',
  SECURITY_CENTER_URL: 'CF_SECURITY_CENTER_URL',
  SERVICE_FILES: 'CF_SERVICE_FILES',
  TARGET_ORIGIN: (client?: string) => setTargetOrigin(APP_ENV, client),
  UNIVERSAL_APIGEE_CLIENT_ID: 'CF_UNIVERSAL_APIGEE_CLIENT_ID',
  UTAG_URL: 'CF_UTAG_URL',
  PROFILE_REMOTE_URL: 'CF_PROFILE_REMOTE_URL',
  STATEMENTS_REMOTE_URL: 'CF_STATEMENTS_REMOTE_URL',
  VANTAGE_REMOTE_URL: 'CF_VANTAGE_REMOTE_URL',
  MAKE_A_PAYMENT_REMOTE_URL: 'CF_MAKE_A_PAYMENT_REMOTE_URL',
  REMOTE_URL: 'CF_REMOTE_URL'
}

const localConfig: ConfigType = {
  API_HOST: 'https://api-qa.syf.com',
  APP_ENV: 'local',
  APPTIMIZE_APP_KEY: 'Bj4eW7qtugZbeJaw9HwZv5rgUSepard',
  AON_AUTHORIZE_URL: 'https://olsbeta.mypaymentsecurity.com/authorize',
  ASSETS_HOST: 'https://qa.synchronycredit.com',
  AUTH_DOMAIN: 'https://auth-qa.syf.com',
  BASENAME,
  COBROWSE: 'staging',
  DCH_HOST_NAME: 'https://qa.synchronycredit.com/paymenthelp',
  DTP_HOST_NAME: 'https://qa.synchronycredit.com/DowntimePay',
  DY_CAMPAIGNS_URL: 'https://qa.synchronycredit.com/dy-api/api/v1/dy/campaigns',
  DY_SECTION_ID: '8776194',
  IVA_HOST: 'ivaqa.synchronycredit.com',
  MARKETPLACE_URL: 'https://qwww.synchrony.com/marketplace',
  PARTNER_APIGEE_CLIENT_ID: 'EzVxCaYzTd9YlBCBjfl1Nk3MAfgw54G2',
  PSCC_APIGEE_CLIENT_ID: 'WeyPqxf4m17Lc309BUbgCG9YmxmmwUIZ',
  PSCC_PAY_AS_GUEST_URL: 'https://q3consumercenter.mysynchrony.com',
  PSCC_URL: 'https://q3consumercenter.mysynchrony.com/consumercenter',
  RC_APIGEE_CLIENT_ID: 'JRNcupSQAq8snBS3q7G731wI0ebp6Hpe',
  SECURITY_CENTER_URL: 'https://dev.synchronycredit.com/signin-security',
  SERVICE_FILES: 'https://qa.synchronycredit.com/serviceFiles/json/qa',
  TARGET_ORIGIN: () => 'https://qa.synchronycredit.com',
  UNIVERSAL_APIGEE_CLIENT_ID: 'G0aFAZvPHNurZSUSJ1RGMcb5FebcSWjr',
  UTAG_URL: 'https://tags.syf.com/synchrony-spa/dev/utag.js',
  PROFILE_REMOTE_URL:
    'https://sit3.synchronycredit.com/profile-mfe/profile-mfe/remoteEntry.js',
  STATEMENTS_REMOTE_URL:
    'https://sit3.synchronycredit.com/profile-mfe/statements-mfe/remoteEntry.js',
  VANTAGE_REMOTE_URL:
    'https://sit3.synchronycredit.com/profile-mfe/vantage-mfe/remoteEntry.js',
  MAKE_A_PAYMENT_REMOTE_URL:
    'https://sit5.synchronycredit.com/make-a-payment/assets/remoteEntry.js',
  REMOTE_URL: 'https://sit3.synchronycredit.com'
}

export default NODE_ENV === 'production' ? prodConfig : localConfig
